<template>
  <div class="card-field-wr">
    <i class="icon-exclamation text-info text-lg"></i>
    <span class="ml-1" v-html="htmlData"></span>
  </div>
</template>

<script>
  export default {
    name: 'Card',
    props: {
      html: {
        type: String,
        default: '',
      },
    },
    computed: {
      htmlData() {
        return this.html || ''
      },
    },
  }
</script>
